export default "__VITE_ASSET__BXikw3$G__"